import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    password,
    oldPassword,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.setSelfPwd, {
        password,
        oldPassword,
    }, options);
    if (error) return { error, status };
    return content || {};
};
